import localeAntd from 'antd/es/locale/it_IT'
import labels from './it.json'
import enlabels from './en_new.json'
import newlabels from './it_new.json'


export default {
  locale: 'it-IT',
  localeAntd,
  messages: {
    ...labels,
    ...enlabels,
    ...newlabels
  },
}
